<template>
  <div :class="b()">
    <el-progress
      ref="progress"
      type="circle"
      :percentage="percentage"
      :color="'#fff'"
      :format="progressFormat"
      :width="60"
    />
  </div>
</template>

<script>
import {
  defineComponent,
  computed,
  ref,
  onMounted,
  onBeforeUnmount
} from 'vue-demi';
import theme from '@zk/theme/lib/variables.scss';

export default defineComponent({
  name: 'VideoAutoCloseProgress',
  bemNS: theme.bemNS,
  props: {
    // 倒计时时间（秒）
    time: {
      type: Number,
      default: 0
    },
    timerStep: {
      type: Number,
      default: 200
    }
  },
  setup: (props, { emit }) => {
    let timer;
    const { timerStep, time } = props;
    const currentTime = ref(time);

    const percentage = computed(() => {
      return Math.round(((time - currentTime.value) / time) * 100);
    });

    const progressFormat = () => {
      return `${Math.ceil(currentTime.value)}`;
    };

    onMounted(() => {
      timer = setInterval(() => {
        if (currentTime.value <= 0) {
          currentTime.value = 0;
          clearInterval(timer);
          emit('complete');
          return;
        }
        currentTime.value -= timerStep / 1000;
      }, timerStep);
    });

    onBeforeUnmount(() => {
      if (timer) {
        clearInterval(timer);
      }
    });

    return {
      progressFormat,
      percentage
    };
  }
});
</script>

<style scoped lang="scss">
@include b(video-auto-close-progress) {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #333;
  color: #fff;
}
</style>
